// The game's ending result, from how the ending started and how the game
// ended (Won, Comeback, Drawn, Blown win, Lost). Like `blunder` it lives in the scan's facts
// (`GameFacts.endingResult`), which the filter does not read: whoever applies
// the filter resolves it first into `ids` (the game store's `resolveFilter`).
// Unresolved, it matches no game.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { ENDING_RESULTS, type EndingResult } from '@chess/api-model';

const LABEL: Record<EndingResult, string> = {
  won: 'Won',
  comeback: 'Comeback',
  drawn: 'Drawn',
  blown: 'Blown win',
  lost: 'Lost',
};

export const endingResult: FilterCriterion<'endingResult'> = {
  key: 'endingResult',
  query: 'ending-result',
  many: true,
  parse: oneOf(ENDING_RESULTS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 66,
    more: true,
    label: 'Ending result',
    options: ENDING_RESULTS.map((r) => [r, LABEL[r]] as [EndingResult, string]),
  },
};
